<div class="ion-padding">
  <div class="video-header">
    <ion-row class="ion-justify-content-center">
      <ion-col size="11">
      </ion-col>
      <ion-col size="1">
        <ion-icon class="icon-close pointer" name="close-circle-outline" (click)="dismissOverlay()"></ion-icon>
      </ion-col>
    </ion-row>
  </div>
  <div class="video-container">    
    <video playsinline controls autoplay>
      <source [src]="videoSrc" type="video/mp4">
    </video>
  </div>
</div>